import update from "immutability-helper";
import {
  //Сообщения об ошибке, успехе, предупреждении
  SHOW_ERROR_MSG,
  HIDE_ERROR_MSG,
  SHOW_SUCCESS_MSG,
  HIDE_SUCCESS_MSG,
  SHOW_WARNING_MSG,
  HIDE_WARNING_MSG,
  //Модальные окна
  OPEN_CANCEL_MODAL,
  CLOSE_CANCEL_MODAL,
  OPEN_AUTH_PHONE_MODAL,
  CLOSE_AUTH_PHONE_MODAL,
  OPEN_DELETE_TEMPLATE_MODAL,
  CLOSE_DELETE_TEMPLATE_MODAL,
  OPEN_DELETE_MESSAGE_MODAL,
  CLOSE_DELETE_MESSAGE_MODAL,
  OPEN_DELETE_QUESTION_MODAL,
  CLOSE_DELETE_QUESTION_MODAL,
  OPEN_CHANGE_LOCALE_MODAL,
  CLOSE_CHANGE_LOCALE_MODAL,
  OPEN_CANCEL_CHANGE_LOCALE_MODAL,
  CLOSE_CANCEL_CHANGE_LOCALE_MODAL,
  OPEN_FILTERS_MODAL,
  CLOSE_FILTERS_MODAL,
  //Сайдбар
  TOGGLE_MENU_HELPER,
  QUESTIONS_COUNT_LOADED_SUCCESSFULLY,
} from '../actions/ui';

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  errorMsg: {
    show: false,
    text: 'Нет соединения с интернетом',
    timeout: 5000,
  },
  successMsg: {
    show: false,
    text: '',
    timeout: 5000,
  },
  warningMsg: {
    show: false,
    text: '',
    timeout: 5000,
  },
  cancelModal: {
    isOpen: false,
  },
  authPhoneModal: {
    isOpen: false,
  },
  deleteTemplateModal: {
    isOpen: false,
  },
  deleteMessageModal: {
    isOpen: false,
  },
  deleteQuestionModal: {
    isOpen: false,
  },
  changeLocaleModal: {
    isOpen: false,
  },
  cancelChangeLocaleModal: {
    isOpen: false,
  },
  filtersModal: {
    isOpen: false,
  },
  menuHelper: {
    isOpen: false,
  },
  countForClients: 0,
  countForConsultants: 0,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    //Сайдбар
    case TOGGLE_MENU_HELPER:
      return update(state, {
        menuHelper: {
          isOpen: {$set: !state.menuHelper.isOpen},
        }
      });
    //Сообщения об ошибке, успехе, предупреждении
    case SHOW_ERROR_MSG:
      return update(state, {
        errorMsg: {
          show: {$set: true},
          text: {$set: action.payload.text}
        }
      });
    case HIDE_ERROR_MSG:
      return update(state, {
        errorMsg: {
          show: {$set: false},
          text: {$set: ''}
        }
      });
    case SHOW_SUCCESS_MSG:
      return update(state, {
        successMsg: {
          show: {$set: true},
          text: {$set: action.payload.text}
        }
      });
    case HIDE_SUCCESS_MSG:
      return update(state, {
        successMsg: {
          show: {$set: false},
          text: {$set: ''}
        }
      });
    case SHOW_WARNING_MSG:
      return update(state, {
        warningMsg: {
          show: {$set: true},
          text: {$set: action.payload.text}
        }
      });
    case HIDE_WARNING_MSG:
      return update(state, {
        warningMsg: {
          show: {$set: false},
          text: {$set: ''}
        }
      });
    //Модальные окна
    case OPEN_CANCEL_MODAL:
      return update(state, {
        cancelModal: {
          isOpen: {$set: true},
        }
      });
    case CLOSE_CANCEL_MODAL:
      return update(state, {
        cancelModal: {
          isOpen: {$set: false},
        }
      });
    case OPEN_AUTH_PHONE_MODAL:
      return update(state, {
        authPhoneModal: {
          isOpen: {$set: true},
        }
      });
    case CLOSE_AUTH_PHONE_MODAL:
      return update(state, {
        authPhoneModal: {
          isOpen: {$set: false},
        }
      });
    case OPEN_DELETE_TEMPLATE_MODAL:
      return update(state, {
        deleteTemplateModal: {
          isOpen: {$set: true},
        }
      });
    case CLOSE_DELETE_TEMPLATE_MODAL:
      return update(state, {
        deleteTemplateModal: {
          isOpen: {$set: false},
        }
      });
    case OPEN_DELETE_MESSAGE_MODAL:
      return update(state, {
        deleteMessageModal: {
          isOpen: {$set: true},
        }
      });
    case CLOSE_DELETE_MESSAGE_MODAL:
      return update(state, {
        deleteMessageModal: {
          isOpen: {$set: false},
        }
      });
    case OPEN_DELETE_QUESTION_MODAL:
      return update(state, {
        deleteQuestionModal: {
          isOpen: {$set: true},
        }
      });
    case CLOSE_DELETE_QUESTION_MODAL:
      return update(state, {
        deleteQuestionModal: {
          isOpen: {$set: false},
        }
      });
    case OPEN_CHANGE_LOCALE_MODAL:
      return update(state, {
        changeLocaleModal: {
          isOpen: {$set: true},
        }
      });
    case CLOSE_CHANGE_LOCALE_MODAL:
      return update(state, {
        changeLocaleModal: {
          isOpen: {$set: false},
        }
      });
    case OPEN_CANCEL_CHANGE_LOCALE_MODAL:
      return update(state, {
        cancelChangeLocaleModal: {
          isOpen: {$set: true},
        }
      })
    case CLOSE_CANCEL_CHANGE_LOCALE_MODAL:
      return update(state, {
        cancelChangeLocaleModal: {
          isOpen: {$set: false},
        }
      })
    case OPEN_FILTERS_MODAL:
      return update(state, {
        filtersModal: {
          isOpen: {$set: true},
        }
      });
    case CLOSE_FILTERS_MODAL:
      return update(state, {
        filtersModal: {
          isOpen: {$set: false},
        }
      });
    //Получение количества вопросов для клиентов и консультантов
    case QUESTIONS_COUNT_LOADED_SUCCESSFULLY:
      return {
        ...state,
        countForClients: action.payload.forClients,
        countForConsultants: action.payload.forConsultants,
      };
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
